/*
 * @Author: likang xie
 * @Date: 2020-04-22 16:14:23
 * @Purpose: 格式化参数
 */

export default (
	search = typeof location != "undefined"
		? location.search || location.hash
		: ""
) => {
	let params = new Object();

	if (!search) return params;

	let str = search.includes("?") ? search.split("?")[1] : search;
	let strs = str.split("&");
	strs.map(
		item =>
			(params[item.split("=")[0]] = decodeURIComponent(item.split("=")[1]))
	);

	console.log("当前获取到的参数：", params);
	return params;
};



// WEBPACK FOOTER //
// ./src/utils/formalParams.js